// Module
var code = `<canvas style="width:100%;height:100%;display:block; cursor: {{.currentCursor}};"
    id="{{.id}}"
    on-mousedown="@this.onMouseDown(event)" 
    on-mousemove="@this.onMouseMove(event)" 
    on-mouseleave="@this.onMouseLeave(event)"
    on-mouseup="@this.onMouseUp(event)" 
    on-wheel="@this.onMouseWheel(event)" 
    on-mousewheel="@this.onMouseWheel(event)" 
    on-click="@this.onClick(event)"
    on-dblclick="@this.onDoubleClick(event)">
</canvas>`;
// Exports
export default code;